import { z } from 'zod';
import { FEED_TYPES, BOTTLE_CONTENTS } from '../constants.ts';

export const feedTypeSchema = z.enum(FEED_TYPES);
export const bottleContentSchema = z.enum(BOTTLE_CONTENTS);

export const breastSegmentSchema = z.object({
  side: z.enum(['left', 'right']),
  from: z.number().int(),
  to: z.number().int(),
});

export const feedStartSchema = z.object({
  type: feedTypeSchema,
  started_at: z.number().int().optional(),
});

export const feedStopSchema = z.object({
  type: feedTypeSchema,
  ended_at: z.number().int().optional(),
});

export const feedCreateSchema = z.object({
  type: feedTypeSchema,
  started_at: z.number().int(),
  ended_at: z.number().int().nullable().optional(),
  amount_ml: z.number().int().min(0).max(2000).nullable().optional(),
  content: bottleContentSchema.nullable().optional(),
  notes: z.string().max(2000).nullable().optional(),
  /** JSON-encoded breast segments. Sent from the edit sheet to overwrite
   *  per-side timing. Sum of segment durations must be ≤ ended_at - started_at. */
  segments: z.array(breastSegmentSchema).nullable().optional(),
});

export const feedPatchSchema = feedCreateSchema.partial();

export type FeedStartInput = z.infer<typeof feedStartSchema>;
export type FeedCreateInput = z.infer<typeof feedCreateSchema>;
export type FeedPatchInput = z.infer<typeof feedPatchSchema>;
